import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import imgErr from '../../Assets/images/pay/erPay.png';
import imgSuccess from '../../Assets/images/pay/sPay.png';
import Loading from "../../Components/Loading";
import { post } from "../../Server";

const PaymentResult = () => {

    const { search: payKey } = useLocation();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState();
    const [statusResponse, setStatusResponse] = useState(false);

    const buyOpions = async () => {
        setLoading(true);
        const { data, status } = await post(
            "/user/pey",
            {
                peykey: payKey.split("=")[1]
            },
            true
        );
        if (+status == 200) {
            setData(data);
            setStatusResponse(true)
        }
        setLoading(false);
    };

    useEffect(() => {
        buyOpions()
    }, [])


    if (loading) return <Loading height={"783px"} />

    return (
        <div className="bg-white rounded border shadow p-4">
            {console.log(statusResponse)}
            <div className="row">
                <div className="col-lg-7">
                    <h2>
                        {statusResponse 
                            ?
                            <span className="text-success border-bottom border-success pb-3 mt-2 d-flex justify-content-center border-3">
                                عملیات با موفقیت انجام شد
                            </span>

                            :
                            <span className="text-danger border-bottom border-danger pb-3 mt-2 d-flex justify-content-center border-3">
                                عملیات با خطا مواجه شد
                            </span>
                        }
                    </h2>

                    <p className="bg-light border rounded d-flex justify-content-between px-2 py-2 shadow-sm mt-5 flex-wrap">
                        <span>
                            کد پیگیری :
                        </span>
                        <span className="fw-bolder">
                            {data?.trackingcode || "-"}
                        </span>
                    </p>

                    <p className="bg-light border rounded d-flex justify-content-between px-2 py-2 shadow-sm mt-4">
                        <span className="font-weight-bold">
                            هزینه تراکنش :
                        </span>
                        <span className="fw-bolder">
                            {data?.price || "-"}  تومان
                        </span>
                    </p>

                    <p className="bg-light border rounded d-flex justify-content-between px-2 py-2 shadow-sm mt-4">
                        <span className="font-weight-bold">
                            موضوع پرداخت :
                        </span>
                        <span className="fw-bolder">
                            {data?.title || "-"}
                        </span>
                    </p>

                </div>

                <div className="col-lg-5">
                    {statusResponse
                        ?
                        <img src={imgSuccess} alt="" width={"100%"} className="p-4" />
                        :
                        <img src={imgErr} alt="" width={"100%"} className="p-4" />
                    }
                </div>
            </div>
        </div>
    )
}

export default PaymentResult;